import React, { useContext, useEffect, useState } from 'react'
import { CButton, CCard, CFormInput } from '@coreui/react'
import uploadIcon from '../../../assets/upload-icon-white.svg'
import FtpSyncLogo from '../../../assets/ftp-syncy-logo.png'
import AwsLogo from '../../../assets/aws-logo.png'
import DropboxLogo from '../../../assets/dropbox-logo.svg'
import BackArrow from '../../../assets/back-arrow-white.svg'
import { AppContext } from 'src/views/context/app'
import { raiseToast } from 'src/views/utils/helper'
import Compressor from 'compressorjs'
import TrailerSelectModal from './trailerSelectModal'
import CustomAccordion from 'src/components/customAccordion/customAccordion'
import useAxios from 'axios-hooks'
import { ACCOUNT_API, JOB_STATUS_API } from 'src/views/utils/urls'
import { isEmpty } from 'lodash'
import ClipboardCopy from 'src/components/copyToClipboard'
import SyncModal from './syncModal'

const AssetUpload = ({ onBack }) => {
  const [trailerModal, setTrailerModal] = useState(false)
  const [trailerFiles, setTrailerFiles] = useState([])
  const {
    setLoader,
    uplaodFilesModal,
    setUplaodFilesModal,
    setUplaodFiles,
    accountObj,
    setUploadFinishCallback,
  } = useContext(AppContext)
  const [fileOver, setFileOver] = useState(false)
  const [syncModalProps, setSyncModalProps] = useState({})
  const [bucketName, setBucketName] = useState('')
  const [regionName, setRegionName] = useState('')
  const [s3Key, setS3key] = useState('')
  const [accessKey, setAccessKey] = useState('')
  const [secretAccessKey, setSecretAccessKey] = useState('')

  const [errorData, setErrorData] = useState({})

  const [ftpData, setFtpData] = useState({
    ip: '',
    username: '',
    password: '',
  })

  const [{ data: userInfo, loading: userInfoLoading }, userInfoCall] = useAxios(
    {
      url: `${ACCOUNT_API}/detail`,
      method: 'get',
    },
    { manual: true },
  )

  const [{ data: syncData }, syncCall] = useAxios(
    {
      url: JOB_STATUS_API,
      method: 'post',
    },
    { manual: true },
  )
  const [{ data: s3SyncData }, s3SyncCall] = useAxios(
    {
      url: JOB_STATUS_API,
      method: 'post',
    },
    { manual: true },
  )

  useEffect(() => {
    if (s3SyncData && s3SyncData.success) {
      setSyncModalProps({
        type: 'success',
        title: 'Sync Request Initiated',
        description:
          'The files are being processed now and will be uploaded to your Asset Manager incrementally. The average processing time for a 10GB file is 15 -20 mins.',
        confirmButtonText: 'OK',
      })
      //   onCancel()
      //   raiseToast('success', 'Sync Started successfully')
    }
    if (s3SyncData && !s3SyncData.success) {
      setSyncModalProps({
        type: 'error',
        title: 'ERROR',
        description: 'Incorrect credentials ( IP Address, User Name, Secret Key etc...)',
        confirmButtonText: 'Retry',
      })
    }
  }, [s3SyncData])

  useEffect(() => {
    if (syncData && syncData.success) {
      setSyncModalProps({
        type: 'success',
        title: 'Sync Request Initiated',
        description:
          'The files are being processed now and will be uploaded to your Asset Manager incrementally. The average processing time for a 10GB file is 15 -20 mins.',
        confirmButtonText: 'OK',
      })
      //   onCancel()
      //   raiseToast('success', 'Sync Started successfully')
    }
    if (syncData && !syncData.success) {
      setSyncModalProps({
        type: 'error',
        title: 'ERROR',
        description: 'Incorrect credentials ( IP Address, User Name, Secret Key etc...)',
        confirmButtonText: 'Retry',
      })
    }
  }, [syncData])

  useEffect(() => {
    setLoader(userInfoLoading)
  }, [userInfoLoading])

  useEffect(() => {
    userInfoCall()
  }, [])

  useEffect(() => {
    if (userInfo && userInfo.success && !isEmpty(userInfo?.data?.ftp_details)) {
      let tempObj = {
        ip: userInfo?.data?.ftp_details?.ip,
        username: userInfo?.data?.ftp_details?.username,
        password: userInfo?.data?.ftp_details?.password,
      }
      setFtpData({ ...tempObj })
    }
  }, [userInfo])

  const handleChange = (event, func) => {
    const { value, name } = event.target
    let temp = errorData
    temp[`${name}`] = ''
    setErrorData({ ...temp })
    func(value)
  }

  const validateInfo = () => {
    let isFormValid = true
    let temp = {}

    if (bucketName.trim().length === 0) {
      isFormValid = false
      temp.bucketName = 'Bucket Name Cannot be Empty!'
    }
    if (regionName.trim().length === 0) {
      isFormValid = false
      temp.regionName = 'Region Cannot be Empty!'
    }
    if (s3Key.trim().length === 0) {
      isFormValid = false
      temp.s3Key = 'S3 Key Cannot be Empty!'
    }
    if (accessKey.trim().length === 0) {
      isFormValid = false
      temp.accessKey = 'Access Key Cannot be Empty!'
    }
    if (secretAccessKey.trim().length === 0) {
      isFormValid = false
      temp.secretAccessKey = 'Secret Access Key Cannot be Empty!'
    }

    setErrorData({ ...temp })
    return isFormValid
  }

  const handleS3Sync = () => {
    if (!validateInfo()) return

    s3SyncCall({
      data: {
        upload_type: 'S3_SYNC',
        customer_id: accountObj?._id,
        aws_credentials: {
          aws_access_key_id: accessKey,
          aws_secret_access_key: secretAccessKey,
          bucket: bucketName,
          s3_directory_key: s3Key,
          region: regionName,
        },
      },
    })
  }

  const handleSync = () => {
    syncCall({
      data: {
        upload_type: 'FTP_SYNC',
        customer_id: accountObj?._id,
      },
    })
  }

  const handleChooseFile = (event) => {
    const files = event.target.files
    checkFileType(files)
  }

  const checkFileType = async (files) => {
    setLoader(true)
    let tempVideoFiles = []
    let finalFiles = []
    const typeArray = ['image', 'video']

    for (let index = 0; index < files.length; index++) {
      let element = files[index]
      console.log('NAAAAMEEEEE', element.type.split('/')[0])
      if (element.type.split('/')[0] === 'video') {
        tempVideoFiles.push(element)
      }
      if (typeArray.includes(element.type.split('/')[0])) {
        if (element.type.split('/')[0] === 'image') {
          await new Promise((resolve) => {
            new Compressor(element, {
              quality: 0.8,
              success: (compressedResult) => {
                // compressedResult has the compressed file.
                compressedResult[`fileType`] = element.type.split('/')[0]
                finalFiles.push(compressedResult)
                resolve()
              },
              error: (err) => {
                console.log(err.message)
                raiseToast('error', 'Image Upload Failed!')
              },
            })
          })
        } else {
          element[`fileType`] = element.type.split('/')[0]
          finalFiles.push(element)
        }
      } else {
        element[`fileType`] = 'other'
        finalFiles.push(element)
      }
    }
    if (finalFiles.length === files.length && tempVideoFiles.length > 0) {
      setTrailerFiles(finalFiles)
      setTrailerModal(true)
      return
    }

    if (finalFiles.length === files.length) {
      handleUploadFiles(finalFiles)
    }
  }

  const handleUploadFiles = async (files) => {
    setUplaodFiles(files)
    setUplaodFilesModal(true)
    setUploadFinishCallback(() => (type) => {
      if (type) {
        onBack()
      }
    })
  }

  const onDragOver = (e) => {
    e.preventDefault()
    // console.log('onDragOver')
    setFileOver(true)
  }

  const onDragLeave = () => {
    // e.preventDefault()
    // console.log('onDragOver')
    setFileOver(false)
  }
  const onDragEnter = () => {
    // console.log('ENTER')
  }

  const onFileDrop = async (e) => {
    e.preventDefault()
    let files = e.dataTransfer.files
    checkFileType(files)
    setFileOver(false)
  }

  let accordionItems = [
    {
      title: 'FTP Sync',
      description:
        'Please be sure that appropriate custom Metadata settings has done for the asset. Otherwise go to the Metadata for more asset settings.',
      children: (
        <div
          style={{ backgroundColor: '#e5e5e5', padding: '0.8rem 2.5rem 2rem 2.5rem' }}
          className=" d-flex flex-column justify-content-center align-items-center"
        >
          <div className="w-100 mt-1">
            <h6 style={{ fontSize: '0.83vw' }} className=" text-left">
              IP Address
            </h6>
            <div>
              <ClipboardCopy copyText={ftpData.ip} />
            </div>
          </div>
          <div
            className=" d-flex justify-content-between w-100 mt-3"
            style={{ gap: '1.75rem 4.4vw' }}
          >
            <div className="" style={{ width: '49%' }}>
              <h6 style={{ fontSize: '0.83vw' }} className="text-left">
                Username
              </h6>
              <div>
                <ClipboardCopy copyText={ftpData.username} />
              </div>
            </div>
            <div className="" style={{ width: '49%' }}>
              <h6 style={{ fontSize: '0.83vw' }} className="text-left">
                Password
              </h6>
              <div>
                <ClipboardCopy copyText={ftpData.password} />
              </div>
            </div>
          </div>
          <div className=" d-flex justify-content-end w-100 mt-5">
            <CButton
              className="text-white px-3"
              style={{ fontSize: '0.9vw', background: '#20211c', borderColor: 'black' }}
              onClick={handleSync}
            >
              Sync
            </CButton>
          </div>
        </div>
      ),
      itemStyle: 'mt-5',
      accordionHeight: '4.6875vw',
      accordionPaddingRight: '1.5rem',
      logo: FtpSyncLogo,
      logoStyle: { width: '1.4vw', marginRight: '1.2vw', marginLeft: '.5vw' },
    },
    {
      title: 'S3 Sync',
      description:
        'Please be sure that appropriate custom Metadata settings has done for the asset. Otherwise go to the Metadata for more asset settings.',
      children: (
        <div
          style={{ backgroundColor: '#e5e5e5', padding: '0.8rem 2.5rem 2rem 2.5rem' }}
          className=" d-flex flex-column justify-content-center align-items-center"
        >
          <div className="w-100 mt-1">
            <h6 style={{ fontSize: '0.83vw' }} className=" text-left">
              Bucket Name
            </h6>
            <div>
              <CFormInput
                name="bucketName"
                value={bucketName}
                onChange={(e) => handleChange(e, setBucketName)}
              />
              <div className="message-text error-message">
                <p>{errorData.bucketName}</p>
              </div>
            </div>
          </div>
          <div
            className=" d-flex justify-content-between w-100 mt-3"
            style={{ gap: '1.75rem 4.4vw' }}
          >
            <div className="" style={{ width: '49%' }}>
              <h6 style={{ fontSize: '0.83vw' }} className="text-left">
                Region
              </h6>
              <div>
                <CFormInput
                  name="regionName"
                  value={regionName}
                  onChange={(e) => handleChange(e, setRegionName)}
                />
                <div className="message-text error-message">
                  <p>{errorData.regionName}</p>
                </div>
              </div>
            </div>
            <div className="" style={{ width: '49%' }}>
              <h6 style={{ fontSize: '0.83vw' }} className="text-left">
                Access Key
              </h6>
              <div>
                <CFormInput
                  name="accessKey"
                  value={accessKey}
                  onChange={(e) => handleChange(e, setAccessKey)}
                />
                <div className="message-text error-message">
                  <p>{errorData.accessKey}</p>
                </div>
              </div>
            </div>
          </div>
          <div
            className=" d-flex justify-content-between w-100 mt-3"
            style={{ gap: '1.75rem 4.4vw' }}
          >
            <div className="" style={{ width: '49%' }}>
              <h6 style={{ fontSize: '0.83vw' }} className="text-left">
                S3 Key
              </h6>
              <div>
                <CFormInput
                  name="s3Key"
                  value={s3Key}
                  onChange={(e) => handleChange(e, setS3key)}
                />
                <div className="message-text error-message">
                  <p>{errorData.s3Key}</p>
                </div>
              </div>
            </div>
            <div className="" style={{ width: '49%' }}>
              <h6 style={{ fontSize: '0.83vw' }} className="text-left">
                Secret Access Key
              </h6>
              <div>
                <CFormInput
                  name="secretAccessKey"
                  value={secretAccessKey}
                  onChange={(e) => handleChange(e, setSecretAccessKey)}
                />
                <div className="message-text error-message">
                  <p>{errorData.secretAccessKey}</p>
                </div>
              </div>
            </div>
          </div>
          <div className=" d-flex justify-content-end w-100 mt-5">
            <CButton
              className="text-white px-3"
              style={{ fontSize: '0.9vw', background: '#20211c', borderColor: 'black' }}
              onClick={handleS3Sync}
            >
              Sync
            </CButton>
          </div>
        </div>
      ),
      itemStyle: 'mt-4',
      accordionHeight: '4.6875vw',
      accordionPaddingRight: '1.5rem',
      logo: AwsLogo,
      logoStyle: { width: '2.08vw', marginRight: '1.2vw' },
    },
    {
      title: 'Dropbox',
      description: 'Add content partners to this content.',
      children: (
        <div
          style={{ backgroundColor: '#e5e5e5', padding: '0.8rem 5rem 2rem 1rem' }}
          className="py-3 pb-5 d-flex flex-column justify-content-center align-items-center"
        ></div>
      ),
      itemStyle: 'mt-4',
      accordionHeight: '4.6875vw',
      accordionPaddingRight: '1.5rem',
      logo: DropboxLogo,
      logoStyle: { width: '1.68vw', marginRight: '1.2vw', marginLeft: '.35vw' },
    },
  ]

  return (
    <>
      <CCard style={{ height: '37vw' }} className="d-flex justify- align-items-center ">
        <div className="w-100 d-flex justify-content-center scrollbar" style={{ height: '90%' }}>
          <div className="" style={{ width: '81.21%' }}>
            <div
              className={`${
                fileOver && 'bg-[#cce6ff] transition ease-in-out delay-150'
              } w-100 d-flex flex-col justify-content-center align-items-center`}
              style={{
                border: '2px solid #818181',
                borderStyle: 'dashed',
                borderRadius: '6px',
                marginTop: '2.2vw',
                paddingTop: '1.3vw',
                paddingBottom: '1.3vw',
              }}
              onDragEnter={(e) => onDragEnter(e)}
              onDragOver={(e) => onDragOver(e)}
              onDragLeave={(e) => onDragLeave(e)}
              onDrop={(e) => onFileDrop(e)}
            >
              <p
                className="mb-0 bold"
                style={{ fontSize: '1vw', opacity: fileOver ? '0.36' : '1' }}
              >
                Drag and Drop your File
              </p>
              <p
                className="mb-0 mt-2 bold text-center"
                style={{ fontSize: '0.9vw', opacity: fileOver ? '0.36' : '1' }}
              >
                or
              </p>
              <label htmlFor="contained-button-file">
                <CButton
                  className="text-white px-3 mt-3"
                  style={{
                    fontSize: '1vw',
                    background: '#20211c',
                    opacity: fileOver ? '0.36' : '1',
                  }}
                  component="span"
                >
                  <img
                    src={uploadIcon}
                    style={{ width: '12.5px', height: '12.5px' }}
                    alt="uploadIcon"
                    className="mr-2"
                  />
                  Choose File
                </CButton>
              </label>
              <input
                type="file"
                hidden
                onChange={(e) => handleChooseFile(e)}
                multiple
                id="contained-button-file"
              />
            </div>

            <CustomAccordion
              items={accordionItems}
              styles={''}
              titleTextStyle={{
                fontSize: '1.5625vw',
                fontWeight: 600,
              }}
            />
          </div>
        </div>
        <div
          style={{ width: '81.21%', height: '10%' }}
          className="d-flex justify-end align-items-center"
        >
          <CButton
            className="text-white px-3 mt-"
            style={{ fontSize: '1vw', background: '#20211c' }}
            onClick={onBack}
          >
            <img
              src={BackArrow}
              style={{ width: '10px', height: '8px' }}
              alt="BackArrow"
              className="mr-4"
            />
            Back
          </CButton>
        </div>
      </CCard>
      {trailerModal ? (
        <TrailerSelectModal
          data={trailerFiles}
          uploadCallback={(files) => {
            setTrailerModal(false)
            handleUploadFiles(files)
            setTrailerFiles([])
          }}
          onCancel={() => {
            setLoader(false)
            setTrailerModal(false)
            setTrailerFiles([])
          }}
        />
      ) : null}
      {!isEmpty(syncModalProps) && (
        <SyncModal
          {...syncModalProps}
          onConfirm={() => {
            setSyncModalProps({})
            onBack()
          }}
        />
      )}
      {trailerModal ? (
        <TrailerSelectModal
          data={trailerFiles}
          uploadCallback={(files) => {
            setTrailerModal(false)
            handleUploadFiles(files)
            setTrailerFiles([])
          }}
          onCancel={() => {
            setLoader(false)
            setTrailerModal(false)
            setTrailerFiles([])
          }}
        />
      ) : null}
    </>
  )
}

export default AssetUpload
